import React, { useState, useEffect } from 'react';
import './courses.css';
import C2wCoursesHoverCard from '../../../common/C2wHome/courses/coursesHoverCard';
import Footer from '../Footer';
import coursesData from "../../../../src/data/coursesData.json"

function C2wCourses() {


    /**
     * @hook useEffect
     * @author Vishal Lohbande
     * @Date 27-05-2025
     *
     * useEffect - Fetches course data from a local JSON file and updates the component state using `setCourseData`.
     *
     * Behavior:
     * - Runs once on component mount (empty dependency array `[]` ensures this).
     * - Initiates a fetch request to "data/coursesData.json".
     * - Parses the response as JSON.
     * - Updates `coursesData` state with the parsed data on successful fetch.
     * - Logs an error to the console if the fetch fails.
     *
     * Usage Scenario:
     * - Commonly used for initializing UI with static or external data (e.g., course listings).
     * - Ensures data is loaded as soon as the component is rendered.
     *
     * Notes:
     * - `coursesData` should initially be `null` or an empty array depending on rendering logic.
     * - The JSON file should be placed correctly in the public directory (for example, `public/data/coursesData.json` if using Create React App or Vite).
     */
    // const [coursesData, setCourseData] = useState(null);
    // useEffect(() => {
    //     fetch("data/coursesData.json")
    //         .then((res) => res.json())               // parse JSON
    //         .then((data) => {
    //             setCourseData(data);
    //         })
    //         .catch((err) => {
    //             console.error("Failed to fetch course details:", err);
    //         });
    // }, []);


    /**
     * @constant windowWidth
     * @author Vishal Lohbande
     *
     * Description:
     * - Stores the current width of the browser window in state.
     * - Initialized with the window's initial inner width.
     */
    /**
     * @function useEffect Hook for window resize listener
     * @author Vishal Lohbande
     *
     * Description:
     * - Sets up an event listener for the window's `resize` event on component mount.
     * - Updates `windowWidth` state whenever the window is resized.
     * - Cleans up the event listener on component unmount to avoid memory leaks.
     *
     * Usage:
     * - Useful for responsive components that depend on the window width.
     *
     * Notes:
     * - The effect runs only once on mount due to empty dependency array `[]`.
     */

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [activeTab, setActiveTab] = useState('Upcoming');

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Filter courses based on activeTab:
    // - activeTab === 'Upcoming' -> type === 'Upcoming'
    // - activeTab === 'Offline' -> type === 'Offline'
    // - activeTab === 'Recorded' -> type === 'Online'
    const filteredCourses = coursesData?.courses?.filter(obj => {
        if (activeTab === 'Upcoming') return obj?.type === 'Upcoming' || obj?.type === 'Fullstack';
        if (activeTab === 'Offline') return obj?.type === 'Offline';
        if (activeTab === 'Recorded') return obj?.type === 'Online';
        return true;
    }) || [];

    const renderdCoursesCards = filteredCourses.map((obj, index) => {
        return <C2wCoursesHoverCard key={obj?.id || index} obj={obj} />
    });

    return (
        windowWidth > 768 ?
            <div className='C2wCourses_ctn_route' data-lenis-prevent>
                <div className='C2wCourses_ctn_route_scroller'>
                    <div className='C2wCoursesHeading_ctn_hld'>
                        <div className='C2wCoursessHeading_ctn'>
                            {'Explore Popular '}
                            <span className='C2wCorsessHeadingSpan'>{'Courses'}</span>
                        </div>
                        <div className='C2wCourses_ctn_subheading'>{'Boost Your Knowledge and Career'}</div>
                    </div>

                    <div className='C2wCourses_main_layout_route'>
                        {/* Left Sidebar Menu */}
                        <div className='C2wCourses_sidebar_route'>
                            <div className='C2wCourses_menu_route'>
                                <button 
                                    className={`C2wCourses_menu_item_route ${activeTab === 'Upcoming' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Upcoming')}
                                >
                                    <span>Upcoming Courses</span>
                                    {activeTab === 'Upcoming' && <span className='chevron-arrow'>&rsaquo;</span>}
                                </button>
                                <button 
                                    className={`C2wCourses_menu_item_route ${activeTab === 'Offline' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Offline')}
                                >
                                    <span>Offline Courses</span>
                                    {activeTab === 'Offline' && <span className='chevron-arrow'>&rsaquo;</span>}
                                </button>
                                <button 
                                    className={`C2wCourses_menu_item_route ${activeTab === 'Recorded' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Recorded')}
                                >
                                    <span>Recorded Courses</span>
                                    {activeTab === 'Recorded' && <span className='chevron-arrow'>&rsaquo;</span>}
                                </button>
                            </div>
                        </div>

                        {/* Vertical Divider */}
                        <div className='C2wCourses_divider_route'></div>

                        {/* Right Grid Content */}
                        <div className='C2wCorses_Hover_card_ctn'>
                            {renderdCoursesCards.length > 0 ? renderdCoursesCards : (
                                <div className="upcoming-course-placeholder">
                                    <div className="placeholder-logos">
                                        <div className="tech-logo-wrapper react-logo">
                                            <img src="/assets/images/landing/reactLogoSvg.svg" alt="React" className="tech-logo" />
                                        </div>
                                        <div className="logos-plus">+</div>
                                        <div className="tech-logo-wrapper spring-logo">
                                            <img src="/assets/images/landing/springLogoSvg.svg" alt="Spring Boot" className="tech-logo" />
                                        </div>
                                    </div>
                                    <h3 className="placeholder-title"><span className="highlight-gradient">Full Stack</span></h3>
                                    <p className="placeholder-desc">Our most awaited course is coming soon. Stay tuned!</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="ADfooter__container courses">
                    <Footer />
                </div>
            </div> :
            <div className='C2wCourses_ctn_route' data-lenis-prevent>
                <div className='C2wCourses_ctn_holder'>
                    <div className='C2wCoursesHeading_ctn_hld'>
                        <div className='C2wCoursessHeading_ctn'>
                            {'Explore Popular '}
                            <span className='C2wCorsessHeadingSpan'>{'Courses'}</span>
                        </div>
                        <div className='C2wCourses_ctn_subheading'>{'Boost Your Knowledge and Career'}</div>
                    </div>

                    {/* Mobile tabs */}
                    <div className='C2wCourses_mobile_tabs_route'>
                        <button 
                            className={`C2wCourses_mobile_tab_btn_route ${activeTab === 'Upcoming' ? 'active' : ''}`}
                            onClick={() => setActiveTab('Upcoming')}
                        >
                            Upcoming
                        </button>
                        <button 
                            className={`C2wCourses_mobile_tab_btn_route ${activeTab === 'Offline' ? 'active' : ''}`}
                            onClick={() => setActiveTab('Offline')}
                        >
                            Offline
                        </button>
                        <button 
                            className={`C2wCourses_mobile_tab_btn_route ${activeTab === 'Recorded' ? 'active' : ''}`}
                            onClick={() => setActiveTab('Recorded')}
                        >
                            Recorded
                        </button>
                    </div>

                    <div className='C2wCorses_Hover_card_ctn'>
                        {renderdCoursesCards.length > 0 ? renderdCoursesCards : (
                            <div className="upcoming-course-placeholder">
                                <div className="placeholder-logos">
                                    <div className="tech-logo-wrapper react-logo">
                                        <img src="/assets/images/landing/reactLogoSvg.svg" alt="React" className="tech-logo" />
                                    </div>
                                    <div className="logos-plus">+</div>
                                    <div className="tech-logo-wrapper spring-logo">
                                        <img src="/assets/images/landing/springLogoSvg.svg" alt="Spring Boot" className="tech-logo" />
                                    </div>
                                </div>
                                <h3 className="placeholder-title"><span className="highlight-gradient">Full Stack</span></h3>
                                <p className="placeholder-desc">Our most awaited course is coming soon. Stay tuned!</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="ADfooter__container courses">
                    <Footer />
                </div>
            </div>
    );
}

export default C2wCourses;
